export default "__VITE_ASSET__DLS$yL_u__"